import React, { useState } from "react";
import DialogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Plus } from "../../svgs/plus.svg";
import { ReactComponent as Minus } from "../../svgs/minus.svg";
// import getSymbolFromCurrency from "currency-symbol-map";
import { formatBalance } from "../../../utils/helper/wallet";
import { LoadingOutlined } from "@ant-design/icons";
import { depositAmount } from "../../../utils/API/depositAmount";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import DepositeBankBetails from "./DepositeBankBetails";

const AddMoneyDialog = ({
  open,
  onAdd,
  onCancel,
  balance,
  updateData,
  setWalletDetails,
  currency,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [money, setMoney] = useState(0);
  const [openDepositBank, setOpenDepositBank] = useState(false);
  const addHandler = async () => {
    try {
      setLoading(true);
      const { updatedWallet } = await depositAmount(money, dispatch);
      setWalletDetails({ ...updatedWallet, wallet_id: updatedWallet._id });
      updateData();
      toast.success("Request sent successfully");
      setMoney(0);
      onAdd();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <DialogBox width={425} open={open} onCancel={onCancel}>
        <h3 className="text-xl font-medium w-fit mx-auto pt-7">Add Money</h3>
        <hr className="border-b-[1px] text-[#4B4B4B] mt-4 mb-6" />
        <div className="text-xl font-normal w-fit mx-auto">
          Current amount -{" "}
          <b className="font-bold">
            {/* {getSymbolFromCurrency(currency)}  */}${" "}
            {formatBalance(Number(balance))}
          </b>
        </div>
        <hr className="border-b-[1px] text-[#4B4B4B] mt-4 mb-5 mx-4" />
        <p className="w-fit mx-auto text-xl font-medium text-[#252525] opacity-60">
          Add
        </p>
        <div className="flex justify-center">
          <div className="w-[190px] divide-x-[2px] divide-blue-800 h-[42px] mt-5 mb-9 border-[2px] border-blue-800 rounded-xl flex">
            <div
              className="w-[15%] flex justify-center items-center cursor-pointer"
              onClick={() => setMoney(money - 1)}
            >
              <div className=" bg-blue-300 w-3 h-3 flex justify-center items-center font-bold text-blue-800 rounded">
                <Minus className="w-4 h-4" />
              </div>
            </div>
            <div className="w-[90%] text-xl font-normal flex justify-center items-center">
              <span className="mr-4"> $</span>
              <input
                className="w-24"
                placeholder="0.00"
                value={money}
                type="number"
                onChange={(e) => {
                  let value = Number(e.target.value || 0);
                  if (e.target.value === "") setMoney("");
                  else if (value >= 0) setMoney(value);
                }}
              />
            </div>
            <div
              className="w-[15%] flex justify-center items-center cursor-pointer"
              onClick={() => setMoney(money + 1)}
            >
              <div className=" bg-blue-300 w-3 h-3 flex justify-center items-center font-bold text-blue-800 rounded">
                <Plus className="w-4 h-4" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center pb-11">
          <Button
            disabled={money === 0 || loading}
            // onClick={addHandler}
            onClick={() => setOpenDepositBank(true)}
            color={"blue"}
            className={
              "text-white w-[125px] h-[40px] rounded-lg text-sm font-bold"
            }
          >
            {loading ? <LoadingOutlined /> : "Add"}
          </Button>
        </div>
      </DialogBox>
      <div>
        <DepositeBankBetails
          open={openDepositBank}
          onCancel={() => setOpenDepositBank(false)}
          addMoney={addHandler}
        />
      </div>
    </div>
  );
};

export default AddMoneyDialog;
